class Time extends HTMLElement {
  /**
   * @param {string} [tag]
   */
  static define(tag = "fslb-time") {
    if (!customElements.get(tag)) {
      customElements.define(tag, this);
    }
  }

  /**
   *
   */
  get current() {
    const timeZone = this.getAttribute("timezone");
    const formatter = new Intl.DateTimeFormat("en-US", {
      hour: "numeric",
      minute: "numeric",
      timeZone,
    });
    const time = formatter.format(new Date());
    return time.replace(/\s+[a|p]m/i, "");
  }

  /**
   *
   */
  constructor() {
    super();
    this.cleanup = new Set();
  }

  /**
   *
   */
  connectedCallback() {
    this.setup();

    const render = () => {
      console.log("render()", this.current);
      this.querySelectorAll("time").forEach((el) => {
        el.innerHTML = this.current;
      });
    };

    render();

    let interval;

    const timeout = setTimeout(
      () => {
        render();
        interval = setInterval(render, 60 * 1000);
      },
      Math.round((60.01 - new Date().getSeconds()) * 1000),
    );

    this.cleanup.add(() => {
      clearTimeout(timeout);
      clearInterval(interval);
    });
  }

  /**
   *
   */
  disconnectedCallback() {
    if (this.cleanup instanceof Set) {
      this.cleanup.forEach((fn) => {
        if (typeof fn === "function") {
          fn();
        }
      });
      this.cleanup.clear();
    }
  }

  /**
   *
   */
  setup() {
    if (!this.querySelector("time")) {
      const time = document.createElement("time");
      this.append(time);
    }
  }
}

Time.define();
